// extracted by mini-css-extract-plugin
export default {"con2":"contact_con2__DkMEA","con1":"contact_con1__Sdlx+","conflex":"contact_conflex__ShyXt","end":"contact_end__6EwO8"};